import { env } from '@/env'
import webapp from '@/services/webapp'
import { ApiError } from '@/services/api'
import { season } from '@/composables/season'
import { sleep } from '@/services/helper'

export async function callApi<T>({ path, body, method, headers }: {
  path: string,
  body?: object,
  headers?: Record<string, string>,
  method: 'POST' | 'DELETE' | 'GET'
}): Promise<T> {
  const response = await fetch(`${env.api.baseUrl}${path}`, {
    method: method,
    headers: Object.assign(
      {
        'Content-Type': 'application/json',
        'x-v': '1.0.0',
      },
      headers ?? {},
      season.value ? { 'x-preview-season': season.value } : {},
    ),
    body: body ? JSON.stringify(body) : (method !== 'GET' ? '{}' : undefined),
  })

  const responseJson = await response.json()
  if (!response.ok) {
    if (response.status === 403) {
      const r = responseJson as { reason: string, banUntil?: number }
      await webapp.showAlert(!r.banUntil ? 'Access denied' : `We’ve detected suspicious bot activity on your account. Access to the game has been temporarily restricted until ${new Date(r.banUntil * 1000).toLocaleString()}.`)
      webapp.close()
      await sleep(1000)
      throw new Error('Access denied')
    }
    const { error } = responseJson as {
      error: { message: string, issues: unknown, metadata?: Record<string, unknown> }
    }
    console.error({ apiError: error })
    if (error.message === 'invalid_season') {
      await webapp.showAlert('The season has ended. Please open the game again.')
      localStorage.clear()
      webapp.close()
    }
    if (error.issues) {
      throw new ApiError('Validation failed', { issues: error.issues })
    } else if (error.message) {
      throw new ApiError(error.message, error.metadata)
    } else {
      throw new ApiError('Unknown error', { error: error })
    }

  }

  return responseJson as T
}
